import { useTheme } from '@/theme';
import { ThemeIds } from '@/theme/themes';
import { useEffect } from 'react';

interface AchievementIconProps {
    icon: string;
    onLoaded?: () => void;
}

export default function AchievementIcon({ icon, onLoaded }: AchievementIconProps) {
    const { themeId } = useTheme();

    function getIcon() {
        if (achievementIcon[themeId]?.[icon]) return achievementIcon[themeId][icon];
        if (defaultIcons[icon]) return defaultIcons[icon];

        console.error('Showing fallback achievement icon');
        return '/assets/global/images/achievements/points.webp';
    }

    const src = getIcon();

    useEffect(() => {
        if (!onLoaded) return;
        const img = new Image();
        img.src = src;
        if (img.complete) {
            setTimeout(onLoaded, 0);
        } else {
            img.onload = onLoaded;
        }
    }, [icon, onLoaded]);

    if (!src) return <></>;
    // getTintFilterStyle('#8FFF97'))
    return <img src={src} alt=" " />;
}

const defaultIcons = {
    badge: '/assets/global/images/achievements/badge.webp',
    mission: '/assets/global/images/achievements/mission.webp',
    points: '/assets/global/images/achievements/points.webp',
    quest: '/assets/global/images/achievements/quest.webp',
    social: '/assets/global/images/achievements/social.webp',
    title: '/assets/global/images/achievements/title.webp',
    tb: '/assets/global/images/achievements/tb.webp',
};

const achievementIcon = {
    // [ThemeIds.Titan]: {
    //     ...defaultIcons,
    //     event: '/assets/global/images/achievements/death.webp',
    // },
};
